<div class="dialog">
    <div class="dialog-title">
        <h6 class="mb-0 mt-0"> Move Parts to Inventory &nbsp;&nbsp;&nbsp;<span class="medium">PO NO:&nbsp;&nbsp;
                {{orderCode}}</span> <img (click)="close()" src="assets/svg/close-white.svg" alt="close"></h6>
    </div>
    <div class="content">
        <p>The following batch of the manufactured part is inspected, and ready to be moved to inventory.</p>
        <div class="container-fluid ml-0r mr-0 no-padding row">
            <div class="col-md-8">
                <div class="container-fluid mr-0 ml-0 row pl-0 mt-3">
                    <div class="col-md-4">
                        <img class="thumbnail" [src]="partData.thumbnail" alt="">
                    </div>
                    <div class="col-md-8">
                        <div>
                            <p class="mb-1 ">PART ID:</p>
                            <h6 class="mb-2 word-break">{{partData?.model_attributes?.model_code}}</h6>
                        </div>
                        <div>
                            <p class="mb-1">PART NAME:</p>
                            <p class="word-break font-weight-bold">{{partData?.model_attributes?.file_name}}</p>
                        </div>
                        <div>
                            <p class="mb-1">BATCH ID:</p>
                            <p class="word-break font-weight-bold">000{{batchId}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-4 mt-5">
                <div class="mt-1 d-flex align-items-center gap-2">
                    <p class="mb-2">TOTAL QTY:</p>
                    <h6 class="mb-2">{{partData?.quantity}}</h6>
                </div>

                <!-- !!! Currently commenting this -->
                <!-- <div class="d-flex align-items-center gap-2">
                    <p class="mb-2">UNINSPECTED QTY:</p>
                    <h6 class="mb-2">{{partData?.quantity - partData?.shipped_count - partData?.inventory_count -
                        ((partData?.quantity===partData?.inventory_count || partData?.quantity===partData?.shipped_count) ? 0 : currentInspectedQty)}}</h6>
                </div> -->
                <div class="d-flex align-items-center gap-2">
                    <p class="mb-2">TOTAL INSPECTION PASSED QTY:</p>
                    <h6 class="mb-2">{{totalPassedQty}}</h6>
                </div>
                <div *ngIf="lastInspectionPassed" class="d-flex align-items-center gap-2">
                    <p class="mb-2">LAST INSPECTION PASSED QTY:</p>
                    <h6 class="mb-2">{{lastInspectionPassed}}</h6>
                </div>
                <div class="d-flex align-items-center gap-2">
                    <p class="mb-2">CURRENT INVENTORY QTY:</p>
                    <h6 class="mb-2">{{currentBatch?.inventoryQuantity ? currentBatch?.inventoryQuantity : '0' }}</h6>
                </div>
                <div class="d-flex align-items-center gap-2">
                    <p class="mb-2">CURRENT SHIPPED QTY:</p>
                    <h6 class="mb-2">{{currentBatch?.shippedQuantity ? currentBatch?.shippedQuantity : '0' }}</h6>
                </div>
                <!-- <p class="">MANUFACTURED QTY</p> -->
                <div class="d-flex align-items-center gap-2">
                    <p class="mb-2">QTY. TO MOVE:</p>
                    <div class="row counter mr-0 ml-0 pl-0">
                        <!-- :DONOT DELETE COMMENTS - CURRENTLY  ALL PASSED QTY TO BE MOVED TO INVENTORY AS PER DESIGN -->
                        <!-- <img (click)="subtractQuantity()" class="pointer" src="assets/svg/Minus.svg" alt=""> -->
                        <input readonly type="text" [(ngModel)]="QtyToMoveToInventory"
                            (change)="changeQty(QtyToMoveToInventory)">
                        <!-- <img (click)="addQuantity()" class="pointer" src="assets/svg/Plus.svg" alt=""> -->
                    </div>
                </div>

            </div>
        </div>
        <div class="container-fluid pt-0 row custom-form mx-0">
            <div class="col px-2">
                <p class="fw-bold mb-1">Inspection Report</p>
                <div class="upload-img-box">
                    <div [formGroup]="demoForm" validate>
                        <file-upload formControlName="files" accept=".jpg,.jpeg,.png,.svg,.pdf">
                            <ng-template let-isFileDragDropAvailable="isFileDragDropAvailable" #placeholder
                                let-control="control" #button>
                                <span *ngIf="isFileDragDropAvailable">
                                    <div _ngcontent-c1="" class="upload-input ng-trigger ng-trigger-zoomAnimation">
                                        <div _ngcontent-c1="" class="icon ng-tns-c1-2 ng-star-inserted">
                                            <svg _ngcontent-c1="" class="ng-tns-c1-2" viewBox="0 0 96 96">
                                                <g _ngcontent-c1="" class="ng-tns-c1-2">
                                                    <path _ngcontent-c1="" class="ng-tns-c1-2"
                                                        d="M62.8,68.1c0-0.6-0.2-1.1-0.6-1.5c-0.4-0.4-0.9-0.6-1.5-0.6s-1.1,0.2-1.5,0.6
                                             c-0.4,0.4-0.6,0.9-0.6,1.5c0,0.6,0.2,1.1,0.6,1.5c0.4,0.4,0.9,0.6,1.5,0.6s1.1-0.2,1.5-0.6S62.8,68.7,62.8,68.1z M71.3,68.1
                                             c0-0.6-0.2-1.1-0.6-1.5c-0.4-0.4-0.9-0.6-1.5-0.6c-0.6,0-1.1,0.2-1.5,0.6C67.2,67,67,67.5,67,68.1c0,0.6,0.2,1.1,0.6,1.5
                                             s0.9,0.6,1.5,0.6c0.6,0,1.1-0.2,1.5-0.6C71.1,69.2,71.3,68.7,71.3,68.1z M75.5,60.7v10.6c0,0.9-0.3,1.6-0.9,2.2
                                             c-0.6,0.6-1.4,0.9-2.2,0.9H23.7c-0.9,0-1.6-0.3-2.2-0.9c-0.6-0.6-0.9-1.4-0.9-2.2V60.7c0-0.9,0.3-1.6,0.9-2.2
                                             c0.6-0.6,1.4-0.9,2.2-0.9h14.1c0.5,1.2,1.2,2.2,2.3,3c1.1,0.8,2.3,1.2,3.7,1.2h8.5c1.3,0,2.6-0.4,3.7-1.2c1.1-0.8,1.9-1.8,2.3-3
                                             h14.1c0.9,0,1.6,0.3,2.2,0.9C75.2,59.1,75.5,59.8,75.5,60.7z M64.8,39.3c-0.4,0.9-1,1.3-2,1.3h-8.5v14.8c0,0.6-0.2,1.1-0.6,1.5
                                             c-0.4,0.4-0.9,0.6-1.5,0.6h-8.5c-0.6,0-1.1-0.2-1.5-0.6c-0.4-0.4-0.6-0.9-0.6-1.5V40.6h-8.5c-0.9,0-1.6-0.4-2-1.3
                                             c-0.4-0.9-0.2-1.6,0.5-2.3l14.8-14.8c0.4-0.4,0.9-0.6,1.5-0.6s1.1,0.2,1.5,0.6L64.3,37C65,37.7,65.1,38.4,64.8,39.3z">
                                                    </path>
                                                </g>
                                            </svg>
                                        </div>
                                        <div class="text-center">
                                            <img class="mb-2" src="assets/svg/upload-file.svg" alt="cube">
                                            <br>
                                        </div>
                                        <br>
                                        <div class="upload-text ng-tns-c1-2 ng-star-inserted text-center">
                                            <b class="center ng-tns-c1-2 ng-star-inserted ml-1">Upload Inspection
                                                Report</b>
                                            <p class="mb-0 mt-2 drag-drop">
                                                (Max. file size 10 MB)</p>
                                        </div>
                                    </div>
                                </span>
                                <span *ngIf="!isFileDragDropAvailable">click</span>
                            </ng-template>
                        </file-upload>
                    </div>
                    <br>
                </div>
            </div>
        </div>
        <div class="button text-right">
            <button class="secondary" (click)="close()">Cancel</button>
            <button [disabled]="clicked" (click)="submit()">Add to Inventory</button>
        </div>
    </div>
</div>